import React from "react";
// import OurValues from "../OurValues/OurValues.jsx";
import "./OurValuesCard.css";

// import cardData from "../../../src/ourValues.json";

const OurValuesCard = () => {
  return (
    <section id="our-service" className="software-services-section">
      <div className="section-header">
        <p className="section-header-top">Our Services</p>
        <h2 className="section-title">Comprehensive Software Solutions</h2>
        <p className="section-subtitle">
          From concept to deployment, we provide end-to-end software development
          services tailored to your business needs.
        </p>
      </div>
      <div className="services-grid">
        <div className="service-card">
          <div className="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="#d67a3a"
                d="M14.18 4.276a.75.75 0 0 1 .531.918l-3.973 14.83a.75.75 0 0 1-1.45-.389l3.974-14.83a.75.75 0 0 1 .919-.53m2.262 3.053a.75.75 0 0 1 1.059-.056l1.737 1.564c.737.662 1.347 1.212 1.767 1.71c.44.525.754 1.088.754 1.784c0 .695-.313 1.258-.754 1.782c-.42.499-1.03 1.049-1.767 1.711l-1.737 1.564a.75.75 0 0 1-1.004-1.115l1.697-1.527c.788-.709 1.319-1.19 1.663-1.598c.33-.393.402-.622.402-.818s-.072-.424-.402-.817c-.344-.409-.875-.89-1.663-1.598l-1.697-1.527a.75.75 0 0 1-.056-1.06m-8.94 1.06a.75.75 0 1 0-1.004-1.115L4.761 8.836c-.737.662-1.347 1.212-1.767 1.71c-.44.525-.754 1.088-.754 1.784c0 .695.313 1.258.754 1.782c.42.499 1.03 1.049 1.767 1.711l1.737 1.564a.75.75 0 0 0 1.004-1.115l-1.697-1.527c-.788-.709-1.319-1.19-1.663-1.598c-.33-.393-.402-.622-.402-.818s.072-.424.402-.817c.344-.409.875-.89 1.663-1.598z"
              />
            </svg>
          </div>
          <h3 className="card-title">Custom Software Development</h3>
          <p className="card-description">
            Tailored solutions built to meet your specific business requirements
            and scale with your growth.
          </p>
        </div>

        <div className="service-card">
          <div className="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="#d67a3a"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M16.286 3H7.714C6.768 3 6 3.806 6 4.8v14.4c0 .994.768 1.8 1.714 1.8h8.572c.947 0 1.714-.806 1.714-1.8V4.8c0-.994-.767-1.8-1.714-1.8M10.5 6h3"
              />
            </svg>
          </div>
          <h3 className="card-title">Mobile App Development</h3>
          <p className="card-description">
            Native and cross-platform mobile applications that deliver
            exceptional user experiences.
          </p>
        </div>

        <div className="service-card">
          <div className="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="#d67a3a"
                d="M6.5 20q-2.275 0-3.887-1.575T1 14.575q0-1.95 1.175-3.475T5.25 9.15q.625-2.3 2.5-3.725T12 4q2.925 0 4.963 2.038T19 11q1.725.2 2.863 1.488T23 15.5q0 1.875-1.312 3.188T18.5 20zm0-2h12q1.05 0 1.775-.725T21 15.5t-.725-1.775T18.5 13H17v-2q0-2.075-1.463-3.538T12 6T8.463 7.463T7 11h-.5q-1.45 0-2.475 1.025T3 14.5t1.025 2.475T6.5 18m5.5-6"
              />
            </svg>
          </div>
          <h3 className="card-title">Cloud Solutions</h3>
          <p className="card-description">
            Scalable cloud infrastructure and migration services to modernize
            your business operations.
          </p>
        </div>

        <div className="service-card">
          <div className="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="#d67a3a"
                d="M12 21q-3.775 0-6.387-1.162T3 17V7q0-1.65 2.638-2.825T12 3t6.363 1.175T21 7v10q0 1.675-2.613 2.838T12 21m0-11.975q2.225 0 4.475-.638T19 7.025q-.275-.725-2.512-1.375T12 5q-2.275 0-4.462.638T5 7.025q.35.75 2.538 1.375T12 9.025M12 14q1.05 0 2.025-.1t1.863-.288t1.675-.462T19 12.525v-3q-.65.35-1.437.625t-1.675.463t-1.863.287T12 11t-2.05-.1t-1.888-.288T6.4 10.15T5 9.525v3q.625.35 1.4.625t1.663.463t1.887.287T12 14m0 5q1.15 0 2.338-.175t2.187-.462t1.675-.65t.8-.738v-2.45q-.65.35-1.437.625t-1.675.463t-1.863.287T12 16t-2.05-.1t-1.888-.288T6.4 15.15T5 14.525V17q.125.375.788.725t1.662.638t2.2.462T12 19"
              />
            </svg>
          </div>
          <h3 className="card-title">Integration Partner</h3>
          <p className="card-description">
            Integration of trusted third-party systems to enhance platform
            functionality and security.
          </p>
        </div>

        <div className="service-card">
          <div className="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
            >
              <path
                fill="#d67a3a"
                fill-rule="evenodd"
                d="M5.25 9.303V8a6.75 6.75 0 0 1 13.5 0v1.303q.34.023.642.064c.9.12 1.658.38 2.26.981c.602.602.86 1.36.982 2.26c.116.867.116 1.97.116 3.337v.11c0 1.367 0 2.47-.116 3.337c-.122.9-.38 1.658-.982 2.26s-1.36.86-2.26.982c-.867.116-1.97.116-3.337.116h-8.11c-1.367 0-2.47 0-3.337-.116c-.9-.122-1.658-.38-2.26-.982s-.86-1.36-.981-2.26c-.117-.867-.117-1.97-.117-3.337v-.11c0-1.367 0-2.47.117-3.337c.12-.9.38-1.658.981-2.26c.602-.602 1.36-.86 2.26-.981q.301-.041.642-.064M6.75 8a5.25 5.25 0 0 1 10.5 0v1.253q-.56-.004-1.195-.003h-8.11q-.634 0-1.195.003zm-3.341 3.409c.277-.277.665-.457 1.4-.556c.754-.101 1.756-.103 3.191-.103h8c1.435 0 2.436.002 3.192.103c.734.099 1.122.28 1.399.556c.277.277.457.665.556 1.4c.101.755.103 1.756.103 3.191s-.002 2.436-.103 3.192c-.099.734-.28 1.122-.556 1.399c-.277.277-.665.457-1.4.556c-.755.101-1.756.103-3.191.103H8c-1.435 0-2.437-.002-3.192-.103c-.734-.099-1.122-.28-1.399-.556c-.277-.277-.457-.665-.556-1.4c-.101-.755-.103-1.756-.103-3.191s.002-2.437.103-3.192c.099-.734.28-1.122.556-1.399"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <h3 className="card-title">Data, ML & AI</h3>
          <p className="card-description">
            Data-driven machine learning and AI solutions to automate insights
            and decisions
          </p>
        </div>

        <div className="service-card">
          <div className="icon-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 16 16"
            >
              <path
                fill="#d67a3a"
                d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09zM4.157 8.5H7a.5.5 0 0 1 .478.647L6.11 13.59l5.732-6.09H9a.5.5 0 0 1-.478-.647L9.89 2.41z"
              />
            </svg>
          </div>
          <h3 className="card-title">Performance Optimization</h3>
          <p className="card-description">
            Enhance your application speed and efficiency with expert
            optimization strategies.
          </p>
        </div>
      </div>
      <div className="service-card service-card--full">
        <div className="icon-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <path
              fill="#d67a3a"
              d="M12 2l9 4v6c0 5-3.5 9.7-9 10-5.5-.3-9-5-9-10V6l9-4z"
            />
          </svg>
        </div>

        <h3 className="card-title">Cybersecurity Solutions</h3>

        <p className="card-description">
          Enterprise-grade cybersecurity services designed to protect digital
          infrastructure, applications, users, and sensitive business data.
        </p>

        {/* NEW TWO-COLUMN LAYOUT */}
        <div className="cyber-grid">
          {/* LEFT SIDE */}
          <div className="cyber-column">
            <h4>Security Services</h4>
            <ul>
              <li>Cloud Security Architecture</li>
              <li>Identity & Access Management (IAM)</li>
              <li>Zero Trust Security Implementation</li>
              <li>Security Monitoring </li>
              <li>Threat Detection</li>
              <li>Vulnerability Assessment</li>
              <li>Penetration Testing</li>
              <li>Security Compliance & Governance</li>
              <li>Endpoint Security</li>
              <li>Network Security</li>
              <li>Secure Infrastructure Design</li>
              <li>Security Operations Support</li>
              <li>Data Protection & Encryption</li>
              <li>Disaster Recovery & Business Continuity</li>
            </ul>
          </div>

          {/* RIGHT SIDE */}
          <div className="cyber-column">
            <h4>Compliance Support</h4>
            <ul>
              <li>NDPA</li>
              <li>GDPR</li>
              <li>ISO 27001</li>
              <li>HIPAA</li>
              <li>SOC Compliance</li>
            </ul>

            <h4>Security Capabilities</h4>
            <ul>
              <li>Azure Security</li>
              <li>Microsoft Defender</li>
              <li>SIEM & Log Analytics</li>
              <li>Multi-Factor Authentication (MFA)</li>
              <li>Conditional Access Policies</li>
              <li>Secure DevSecOps</li>
              <li>Defensive Coding Practices</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurValuesCard;
